<template>
	<div class="markdown prose">
        <h3 class="text-black01 font-weight-bold">GENERATIONAL WEALTH CREATION FRAMEWORK</h3>
        <p >Executive Overview: Long-term value creation requires patience, conviction, and disciplined execution. Untrading presents an innovative solution for building and preserving multi-generational wealth.</p>
        <p class="text-black01 font-weight-bold">Core Strategy: Value Perpetuity Protocol™</p>
        <ul class="ml-8 custom-ul">
            <li>Strategic Position Management</li>
            <li>Future Rewards Generation</li>
            <li>Legacy Wealth Protection</li>
            <li>Perpetual Growth Engine</li>
        </ul>
        <p class="text-black01 font-weight-bold">Implementation Methodology:</p>
        <ol class="ml-8 custom-ol">
            <li>Value Assessment</li>
            <li>Position Optimization</li>
            <li>Income Generation</li>
            <li>Legacy Planning</li>
        </ol>
        <p class="text-black01 font-weight-bold">Key Advantages:</p>
        <ul class=" ml-8 custom-ul">
            <li>Enhanced Value Capture</li>
            <li>Perpetual Return Streams</li>
            <li>Complete Asset Control</li>
            <li>Generational Wealth Transfer</li>
        </ul>
        <p class="text-black01 font-weight-bold">Value Preservation:</p>
        <ul class="ml-8 custom-ul">
            <li>Strategic Exit Flexibility</li>
            <li>Continuous Income Creation</li>
            <li>Multi-generational Planning</li>
            <li>Legacy Protection</li>
        </ul>
        <p >Contact our legacy planning team to explore how Untrading can transform your long-term value creation strategy.</p>
    </div>
</template>